/**
 * Extract a user-facing message from an API error response.
 * Returns the message (with its code, if any) only for 4xx responses (except 401)
 * whose JSON body contains a non-empty `message`, otherwise null.
 */
export function getApiErrorMessage(error: any): string {
  if (!error || typeof error.status !== 'number') {
    return null;
  }
  if (error.status < 400 || error.status >= 500 || error.status === 401) {
    return null;
  }
  let body;
  try {
    body = JSON.parse(error._body);
  } catch (err) {
    return null;
  }
  if (!body || typeof body.message !== 'string' || !body.message.trim()) {
    return null;
  }
  const hasCode = body.code !== undefined && body.code !== null && body.code !== '';
  return hasCode ? `${body.message} (${body.code})` : body.message;
}



// WEBPACK FOOTER //
// ./src/app/providers/api-error.ts